
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/author/become-author",
      function () {
        return require("private-next-pages/author/become-author/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/author/become-author"])
      });
    }
  